"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgChatOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M28.9 11.7a9.8 9.8 0 00-5.76-2.49 12.18 12.18 0 01.2 2 7.46 7.46 0 014.14 1.86A5.83 5.83 0 0129 17.5c0 2.83-1.09 4.61-3.39 5.59l-.61.26v3.71L20.7 24H20c-3.61 0-6.06-.69-7.48-2.11-.06-.07-.1-.15-.16-.21l-1.65 1.17c.13.15.26.31.4.45C12.9 25.12 15.81 26 20 26h.1l6.9 4.94v-6.29c2.65-1.37 4-3.77 4-7.14a7.86 7.86 0 00-2.1-5.81z" }),
        React.createElement("path", { d: "M10.92 19c6.24-.07 9.41-2.59 9.43-7.5a7 7 0 00-1.86-5.12C16.89 4.78 14.33 4 10.66 4 4.26 4 1 6.52 1 11.5a6.56 6.56 0 003 6v6.42zM3 11.51C3 8.94 3.88 6 10.66 6c3.11 0 5.2.59 6.41 1.8a5 5 0 011.28 3.7c0 2.56-.89 5.5-7.74 5.5h-.33L6 20.06v-3.73l-.54-.28C3.77 15.19 3 13.74 3 11.51z" })));
}
exports.default = SvgChatOutline;
//# sourceMappingURL=ChatOutline.js.map